export class PaginatedSearchJournalRequest {
  readonly "@type": string;
  readonly skipIdList: number[];
  readonly pageSize: number;

  constructor(skipIds: number[]) {
    this["@type"] = ".PaginatedSearchJournalRequest";
    this.skipIdList = skipIds;
    this.pageSize = 10;
  }
}
